// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import {router} from './router'
import * as VueGoogleMaps from 'vue2-google-maps'
import Vuelidate from 'vuelidate'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import Vue2Editor from "vue2-editor";

import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import 'vue-search-select/dist/VueSearchSelect.css'

// todo
// cssVars()

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({types: toastTypes})
function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}


Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueNotifications, options)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB2sn-FVl6cqtSIg4dPSUjqGXWw1pfkmso',
    //key: 'AIzaSyBzlLYISGjL_ovJwAehh6ydhB56fCCpPQw',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
})

Vue.use(VCalendar, {
  firstDayOfWeek: 2,
  datePickerShowDayPopover: false,
  locale: 'id-ID',
  formats: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['DD MMM YYYY'],
    dayPopover: 'D',
    data: ['YYYY-MM-DD']
  }
})

Vue.use(Vue2Editor);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
